import consumer from "./consumer"

consumer.subscriptions.create("MessageChannel", {
  connected() {
    console.log("------------connected to the channel--------------")
  },

  disconnected() {
    console.log("------------disconnected--------------")
  },

  received(data) {
    if (data.type === 'new_message') {
      var convId = data.conversation_id;
      var isActive = $('.conversation_' + convId).hasClass('active') ||
                     parseInt($('#conversation-data').data('conversation-id')) === convId;

      // Get current user's ID from the page by finding elements with the unread-message-count-{id} pattern
      var currentUserId = null;
      $('[class*="unread-message-count-"]').each(function() {
        var classes = $(this).attr('class');
        var match = classes.match(/unread-message-count-(\d+)/);
        if (match) {
          currentUserId = parseInt(match[1]);
          return false; // break the loop
        }
      });

      console.log('Current User ID:', currentUserId, 'Broadcast owner_id:', data.owner_id);

      // Check if this message belongs to the current user's conversations
      // If owner_id doesn't match current user, ignore this broadcast
      if (currentUserId && data.owner_id && data.owner_id !== currentUserId) {
        console.log('Ignoring broadcast - owner_id does not match current user');
        return;
      }

      // Always update message preview on sidebar card
      if (data.message_text) {
        var preview = data.message_text.substring(0, 25) + (data.message_text.length > 25 ? '...' : '');
        $('.message-preview-' + convId).text(preview);
      }

      if (isActive) {
        // Conversation is open — prepend message to chat section (column-reverse layout)
        var $chat = $('#messageCampaign-' + convId);
        if (!$chat.length) return;
        var isAtBottom = $chat.scrollTop() <= 50;
        var messageHtml = '<div class="received-message">' +
          '<span>' + data.created_at + '</span><br>' +
          '<p class="message-text">' + data.message_text + '</p><br>' +
        '</div>';
        $chat.prepend(messageHtml);
        if (isAtBottom) {
          $chat.scrollTop(0);
        } else {
          // Position indicator centered in chat window, above reply area
          var chatWin = document.querySelector('.chat-window');
          var replyContent = document.querySelector('.reply-messages-section .content-wrapper');
          if (chatWin) {
            var chatRect = chatWin.getBoundingClientRect();
            var bottomOffset = 150;
            if (replyContent) {
              var replyRect = replyContent.getBoundingClientRect();
              bottomOffset = window.innerHeight - replyRect.top + 15;
            }
            $('#new-message-wrapper').css({
              left: (chatRect.left + chatRect.width / 2) + 'px',
              bottom: bottomOffset + 'px'
            });
          }
          $('#new-message-wrapper').show();
        }
      } else {
        // Conversation is not open — add blue dot
        var $timeArrow = $('.conversation_' + convId + ' .time_arrow');
        if ($timeArrow.length && !$timeArrow.find('.unread-dot').length) {
          $timeArrow.prepend('<span class="unread-dot unread-dot-' + convId + '"></span>');
        }

        // Increment sidebar badge for the conversation's tab
        var statusBadgeMap = {
          'PendingReengagement':    '.sidebar-unread-status-0',
          'Blocked':                '.sidebar-unread-status-2',
          'Trash':                  '.sidebar-unread-status-3',
          'HotLeads':               '.sidebar-unread-status-5',
          'Booked':                 '.sidebar-unread-status-6',
          'Proposals':              '.sidebar-unread-status-7',
          'FollowUps':              '.sidebar-unread-status-8',
          'ClosedWon':              '.sidebar-unread-status-9',
          'Dead':                   '.sidebar-unread-status-10',
          'LinksClickedAndReplied': '.sidebar-unread-status-11',
          'leads':                  '.sidebar-unread-status-12'
        };
        var badgeSel = statusBadgeMap[data.conversation_status];
        if (badgeSel) {
          var $badge = $(badgeSel);
          var cur = parseInt($badge.text().replace(/,/g, '')) || 0;
          $badge.text((cur + 1).toLocaleString('en-US')).show();
        }
        // Increment total
        var $total = $('.unread-num');
        var totalCur = parseInt($total.text().replace(/,/g, '')) || 0;
        $total.text((totalCur + 1).toLocaleString('en-US'));
      }
      return;
    }

    // Legacy code path - also check user_id matches current user
    var currentUserId = null;
    $('[class*="unread-message-count-"]').each(function() {
      var classes = $(this).attr('class');
      var match = classes.match(/unread-message-count-(\d+)/);
      if (match) {
        currentUserId = parseInt(match[1]);
        return false; // break the loop
      }
    });

    console.log('Legacy path - Current User ID:', currentUserId, 'Broadcast user_id:', data['user_id']);

    // If user_id doesn't match current user, ignore this broadcast (legacy path)
    if (currentUserId && data['user_id'] && data['user_id'] !== currentUserId) {
      console.log('Ignoring legacy broadcast - user_id does not match current user');
      return;
    }

    var id = data.id
    $('#messageCampaign-' + id).append('<div class="received-message"><p>' + data['conversation'].message_text +'</p></div>')
    $('.conversation_notification_' + data['user_id']).html(data['un_read_count'])
    if ($('.sms_conversation_' + data['user_id'])[0]) {
      $('.sms_conversation_' + data['user_id'])[0].innerHTML = data['partial_html']
    }
    $(document).ready(function() {
      const filterTabs = document.querySelectorAll('.filter-tab');
      const messageCards = document.querySelectorAll('.whole-message');
      const preFilter = localStorage.getItem('selectedTab') || 'all';
      filterTabs.forEach(t => t.classList.remove('active'));
      document.querySelector("[data-filter="+ preFilter+"]").classList.add('active');
      messageCards.forEach(card => {  
        if (preFilter === 'all') {
          card.style.display = 'block';
        } else if (card.getAttribute('data-status') === preFilter) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      });
          
      filterTabs.forEach(tab => {
        tab.addEventListener('click', function () {
          // Remove active class from all tabs and set it to the clicked tab
          filterTabs.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
  
          // Get the filter type
          const filter = this.getAttribute('data-filter');
          localStorage.setItem('selectedTab', filter)
          // Filter messages based on the clicked filter
          messageCards.forEach(card => {
            if (filter === 'all') {
              card.style.display = 'block';
            } else if (card.getAttribute('data-status') === filter) {
              card.style.display = 'block';
            } else {
              card.style.display = 'none';
            }
          });
        });
      });
    });
    $('.unread-message-count-' + data['user_id']).html(data['un_read_count'])
    $('.lead-unread-message-count-' + data['user_id']).html(data['lead_un_read_count'])
    $('.sms-balance').html(data['sms_balance'] + '/' +  data['remain_balance'])
    $('.clicked-message-count-' + id).html(data['clicked_unread_count'])
  }
});
